<template>    
	<div class="container" style="padding-bottom: 80px;">
		<div class="row pb-2 h-100">
			<div class="mt-2" v-if="!editing" key="list">
				<button 
					type="button" 
					v-on:click="userEdit(false)"
					class="btn btn-sm btn-primary">
						<i class="fas fa-user-plus"></i> Add an account
				</button>
				<div v-if="!$root.loading && $root.userData.length">                
					<div class="form-row mt-2">			
						<div class="col search input-group form-label-group">
							<input type="text" class="form-control" v-model="search" placeholder="Type a user name to begin searching...">
							<label>Type an account name, account manager name or sales team member name to begin searching...</label>
							<button type="button" :disabled="search == ''" v-on:click="search = ''" class="btn btn-secondary"><i class="fas fa-times"></i> Clear</button>							
						</div>			
					</div>	
					<div class="card mb-3">
						<ul class="list-group list-group-flush">
							<li class="list-group-item" :class="{'inactive': n.enabled == 'no'}" v-for="n in paginatedData"> 
								<div class="float-start">
									<span class="h4 long-name" v-html="$options.filters.highlight(n.description, search)"></span>	
									<span class="badge badge-pill bg-info ms-2" v-if="n.properties.active == 'no'"> <i class="fa fa-bell" aria-hidden="true"></i> Disabled</span>											
									<div class="mt-1 mb-1" style="min-width: 700px">	
										<div class="detail"><span class="text-secondary">IAM:</span> <span class="text-info" v-html="$options.filters.highlight(staffDisplay(n.properties.iam, 'iam'), search)"></span></div>
										<div class="detail"><span class="text-secondary">Sales:</span> <span class="text-info" v-html="$options.filters.highlight(staffDisplay(n.properties.sales, 'sales'), search)"></span></div>
									</div>
								</div>                                         								
								<div class="float-end">
									<div class="text-end">
										<button 
											type="button"
											v-on:click="userEdit(n);" 
											:disabled="deleting"
											class="btn btn-sm btn-success me-1"                                
										><i class="fas fa-pencil-alt"></i> Edit</button>
										<button 
											type="button"
											v-on:click="n.deleting = true;"
											class="btn btn-sm btn-danger me-2"
											:disabled="n.deleting || deleting"
										><i class="fas fa-trash"></i> Delete</button>                                               
									</div>
									<div class="float-end pt-2" v-show="n.deleting">
											<span class="text-danger">Are you sure?</span>  
											<button type="button" :disabled="deleting" v-on:click="userDelete(n)" class="btn btn-sm btn-success ms-1 me-1"><i class="fas fa-check"></i> Yes</button>
											<button type="button" :disabled="deleting" v-on:click="n.deleting = false;" class="btn btn-sm btn-danger me-2"><i class="fas fa-times"></i> No</button>
									</div>
								</div>								
							</li>                                
						</ul>
						<div class="card-footer">
							<div class="row">
								<div class="col-2">
									<button class="btn btn-primary" type="button" :disabled="pageNumber == 0" v-on:click="prevPage()"><i class="fas fa-chevron-left"></i> Back</button>
								</div>
								<div class="col-8 mt-2" style="text-align: center">
									<span v-if="pageCount > 0">page {{pageNumber + 1}} of {{pageCount}}</span>
									<span v-else>Your search returned no results</span>
								</div>
								<div class="col">
									<button class="float-end btn btn-primary" type="button" :disabled="pageNumber == pageCount - 1 || pageCount == 0" v-on:click="nextPage()">Next <i class="fas fa-chevron-right"></i></button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="!$root.loading && !$root.userData.length" class="border-top mt-2 pt-2">
					<h3><i class="text-primary far fa-square"></i> <span>No accounts exist, yet.</span></h3>
				</div>
				<div v-if="$root.loading" class="border-top mt-2 pt-2">
					<h2><i class="text-primary fas fa-circle-notch fa-spin"></i> Loading...</h2>	
				</div>							
			</div>
			<div v-if="editing" key="alias">
				<edit></edit>				
			</div>
		</div>	        
	</div>  
</template>

<script>
const defaultState = {
	id: "",  
  	name: "",
  	description: "",
  	properties: {
    	type: "user",
    	password: "",
    	active: "no",
		bluerock: "no",
		iam: "",
		sales: ""	
  	},
  	external: {
    	logo: "",
    	message: "",
    	access: []
  	}
};

import edit from './users/edit.vue';
import { userState } from './users/user.state.js';
import { Modal } from 'bootstrap';

export default {
	components: {					
        edit: edit
	},

	data: function() {
    	return {	
			userState,            
            editing: false,				
			users: [],	
			user: null,		
            currentUser: null,
            search: '',
			loading: false,
			deleting: false, //Global deleting indicator
			size: 5, //Elements per page
            pageNumber: 0 //Current page number
		}
	},
	methods: {	
		staffDisplay: function(record, type) {
			let tmp;
			try {
				tmp = JSON.parse(record);	
			} catch (e) {
				tmp = [];
			}			
			let out = 'Not assigned';
			let a = [];		
			let staff = this.$root.staffData.filter(s => { return s.properties.role == type; });	
			for (let i = 0; i < tmp.length; i++) {
				let r = staff.filter(s => { return s.id == tmp[i].id });
				if (r.length > 0) { 
					a.push(r[0].description);
				}
			}			
			if (a.length > 0) {
				out = a.join(', ');
			}
			return out;
		},
		userEdit: function(user) {		
			if (user) {		
				let u = JSON.parse(JSON.stringify(user));		
				this.loading = true;
				var _this = this;				
				this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/file.get.php', {params: {id: user.id, action: 'read'}})
            	.then(response => {				
					if (response.data.error) {
						_this.loading = false;
						_this.$root.setAlert(true, response.data.error, 'alert-danger');              
						return;
					} else {												
						_this.userState.id = u.id;
						_this.userState.name = u.name;
						_this.userState.description = u.description;
						_this.userState.properties = u.properties;		
						try {
							_this.userState.properties.iam = JSON.parse(u.properties.iam);
						} catch (e) {
							_this.userState.properties.iam = [];
						}
						try {
							_this.userState.properties.sales = JSON.parse(u.properties.sales);
						} catch (e) {
							_this.userState.properties.sales = [];
						}
						_this.userState.external = response.data;
						_this.user = JSON.parse(JSON.stringify(_this.userState));
						_this.loading = false;
					}
	            });	
			} else {								
				this.userState = JSON.parse(JSON.stringify(defaultState));
				this.user = JSON.parse(JSON.stringify(defaultState));
				this.loading = false;
			}
			this.editing = true;			
		},
		userDelete: function(user) {
			var _this = this;	
			this.deleting = true;		
			var postData = {
				type: 'user',
				action: 'delete',
				data: {
					id: user.id
				}		
			};
			this.axios({
				method: 'post'
				,url: _this.$config[process.env.VUE_APP_ENV].app.base+'data/php/user.update.php'
				,headers: {'Content-Type': 'application/x-www-form-urlencoded'}
				,data: $.param(postData)             
			}).then(function(response) {     
				if (response.data.error) {	
					_this.deleting = false;		
					_this.$root.setAlert(true, response.data.error, 'alert-danger');						
					return;
				} else {
					_this.$root.userData = _this.$root.userData.filter(u => { return u.id != user.id });
					_this.userState = JSON.parse(JSON.stringify(defaultState));
					_this.deleting = false;
					_this.$root.setAlert(true, 'User deleted successfully', 'alert-success');						
				}
			}); 
		},
        nextPage: function() {
            if (this.pageNumber < this.pageCount) {
                this.pageNumber++;
            }
        },
        prevPage: function() {
            if (this.pageNumber > 0) {
                this.pageNumber--;
            }
        },
        setUser: function(data) {
            this.currentUser = data;
        },
		hideContextMenu(id) {
      		const element = document.getElementById(id);
      		if (element) {
        		element.classList.remove("vue-simple-context-menu--active");
        		//this.$emit("menu-closed");
      		}
    	},			
		addDocument: function() {
			$("#fileUpload").trigger("click");			
		},			
		uploadFiles: function() {
			if (this.$refs.fileUpload.files.length > 0) {
				this.$root.processing = true;
				var _this = this;
				var data = {
					parent: this.$root.currentFolder.id,
					action: 'add'				
				};				
				var formData = new FormData();
				formData.append("data", JSON.stringify(data));
				for (var f = 0; f < this.$refs.fileUpload.files.length; f++) {
					formData.append("files[]", this.$refs.fileUpload.files[f]);
				}
				this.axios({
					method: 'post'
					,url: _this.$config[process.env.VUE_APP_ENV].app.base+'data/php/file.update.php'
					,headers: {'Content-Type': 'multipart/form-data'}				
					,data: formData
				})
				.then(function(response) {							
					_this.$root.processing = false;
					if (response.data.error) {	
						_this.$root.setAlert(true, response.data.error, 'alert-danger');									
						return;
					} else {     						        
						for (let i = 0; i < response.data.length; i++) {
							_this.$root.driveData.unshift(response.data[i])
						}						
						_this.$root.setAlert(true, 'Files added successfully', 'alert-success');					
					}
				});
			}	
		},
    	setAlert: function(display, message, css, icon) {
			this.$root.setAlert(display, message, css, icon);			
		},
		clearAlert: function() {
			this.$root.clearAlert();
		},		
				
	},
	computed: {		
        filtered: function() {
            var s = this.search.toLowerCase();
            return this.$root.userData;
            /*.filter(a => {                
               return a.username.toLowerCase().includes(s)
               //a.displayName.toLowerCase().includes(s) || 
               // a.iamDisplay.toLowerCase().includes(s) ||
               // a.salesDisplay.toLowerCase().includes(s);
            });*/
        },
        pageCount: function() {
            let l = this.filtered.length;
            let s = this.size;
            var c = Math.ceil(l/s);            
            return c;
        },
        paginatedData: function() {            
            if (this.pageNumber >= this.pageCount) {                
                this.pageNumber = 0;
            }
            const start = this.pageNumber * this.size;            
            const end = start + this.size;
            return this.filtered.slice(start, end);
        } 
	},
	mounted() {
		this.$root.getUsers();
        //this.modalUserEdit = new Modal(document.getElementById('modalUserEdit'));
	},
	watch: {	
		'$route': function(newVal, oldVal) {			
			this.$root.getUsers();
		}				
	}
}
</script>
<style>
#fileUpload, #fileUpdate {
	display: none;
}
.form-label-group .input-group-text input {
	height: inherit;
	padding-left: 5px !important;
	padding-top: 13px !important;
}

.custom-control-label {
	padding-left: .25rem;
	padding-top: 0.1rem;
}
.custom-control-label::before, 
.custom-control-label::after {  
  width: 1.25rem;
	height: 1.25rem;	
}

@keyframes editing {
 0%  {margin-left: 0px;}
 100% {margin-left: 20px;}
}

@keyframes subdued {
 0%  {margin-left: 20px;}
 100% {margin-left: 0px;}
}

.display-5 {
  font-size: 2.0rem;
  font-weight: 300;
  line-height: 1.2;
}
</style>